export const fr_lang_keys = {
  site_title: 'Interaction 21 • 31 janvier au 5 février 2021',
  meta_description:
    "En 2021, la Semaine d'Interaction sera virtuelle pour la première vois, avec pour thème: Design in perilous times",
  nav_menu: 'MENU',
  nav_tickets_avail_soon: 'Billets disponibles bientôt',
  nav_get_tickets: 'Billeterie',
  nav_close: 'FERMER',
  nav_color_mode: 'Mode',
  nav_dark: 'Foncé',
  nav_light: 'Clair',
  about_heading: 'À propos',
  about_team_h2: "L'équipe d'Interaction 21",
  about_team_text:
    'Interaction 21 est possible grâce au dévouement de ces individus passionés.',
  get_involved_heading: 'Impliquez-vous',
  faq_heading: 'FAQ',
  cfp_title: 'Appel aux propositions',
  coc_title: 'Code de conduite',
  privacy_title: 'Politique de confidentialité',
  accessibility_title: 'Accessibilité',
  footer_join_the_conversation: 'Contactez-nous',
  footer_get_involved: 'Impliquez-vous',
  footer_follow_the_movement: 'Suivez le mouvement',
  footer_sub_to_our_newsletter: 'Abonnez-vous à notre infolettre',
  footer_enter_your_email: 'Entrez votre adresse courriel',
  footer_subscribe_btn: 'Soumettre',
  footer_coc: 'Code de conduite',
  footer_privacy: 'Confidentialité',
  footer_copyright: 'Copyright Interaction Design Association',
  footer_accessibility: 'Accessibilité',
};
